// extracted by mini-css-extract-plugin
export var cartContainer = "_mu-4";
export var gray = "_mu-1";
export var itemContainer = "_mu-2";
export var itemDetails = "_mu-3";
export var strong = "_mu-0";